import { pendingQuoteStatuses } from '@features/invoices/constants/pendingQuoteStatuses'
import { QuoteStatus } from '@features/invoices/enums/quoteStatus'

interface QuoteMarkabilityStatus {
  isMarkableAsSent: boolean
  isMarkableAsUnsent: boolean
}

export const getQuoteMarkabilityStatus = (
  quoteStatus: QuoteStatus | undefined,
  hasSentEvents: boolean | undefined,
): QuoteMarkabilityStatus => {
  const isPending = !!quoteStatus && pendingQuoteStatuses.includes(quoteStatus)
  const isMarkableAsSent =
    isPending && (quoteStatus === QuoteStatus.Unsent || (quoteStatus !== QuoteStatus.Sent && !hasSentEvents))
  const isMarkableAsUnsent = isPending && !isMarkableAsSent

  return { isMarkableAsSent, isMarkableAsUnsent }
}
